import { isFunction } from 'lodash';
import { getNodeId } from '../store/actionHandlers/common/adapterActions';

export default class RadioHierarchySelection {
  constructor({ canSelectNode = true } = {}) {
    this._canSelectNode = isFunction(canSelectNode)
      ? canSelectNode
      : () => canSelectNode;
  }

  get key() {
    return 'selection';
  }

  get selectionVisuals() {
    return 'radio';
  }

  canSelectNode(node) {
    if (isFunction(this._canSelectNode)) {
      return !!this._canSelectNode(node);
    }
    return !!this._canSelectNode;
  }

  prepareTreeState(treeState) {
    treeState.selection = [];
    treeState.selectedLeafId = null;
    treeState.selectedIds = {};
  }

  getSelection(treeState) {
    return treeState.selection;
  }

  setSelection(treeState, selection, { adapter }) {
    treeState.selection = selection;

    treeState.selectedLeafId = selection.length
      ? getNodeId(adapter, selection[0])
      : null;

    treeState.selectedIds = selection.reduce((hash, node) => {
      hash[getNodeId(adapter, node)] = true;
      return hash;
    }, {});
  }

  nodeIsSelected(treeState, nodeId) {
    return treeState.selectedLeafId === nodeId;
  }

  nodeIsIntermediate(treeState, nodeId) {
    return (
      treeState.selectedLeafId !== nodeId && !!treeState.selectedIds[nodeId]
    );
  }

  nodeIsSelectable(node) {
    return this.canSelectNode(node);
  }

  toggleNodeSelected(treeState, nodeId) {
    const { models, parents } = treeState;

    const selectedLeafId = nodeId;
    const selectedIds = { [nodeId]: true };
    const selection = [models[nodeId]];

    let parentId = parents[nodeId];
    while (parentId) {
      selectedIds[parentId] = true;
      selection.push(models[parentId]);
      parentId = parents[parentId];
    }

    return {
      ...treeState,
      selectedLeafId,
      selectedIds,
      selection,
    };
  }
}
